if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "test") {
  module.exports = require("./configureStore.prod");
} else {
  console.warn("NOT PRODUCTION ENVIRONMENT:", process.env.NODE_ENV);
  module.exports = require("./configureStore.dev");
}
